import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";


export type R3TabPanelRow = {
	name: string;
	header: string;
	visible: boolean;
}


export class R3TabPanelClass extends R3VisualComponentBase {

	activeIndex = ref(0);



	setTabFocusByIndex = (index: number) => {
		this.activeIndex.value = index;
	}

	setTabFocusByName = (name: string) => {
		const index = this.panels.value.findIndex((panel) => panel.name === name);
		if (index !== -1) {
			this.panels.value[index].visible = true;

			this.visiblePanels.value = this.panels.value.filter(i => i.visible == true);

			this.activeIndex.value = this.getVisibleTabIndexByName(name);
		}
	};

	getVisibleTabIndexByName(name: string) {

		return this.visiblePanels.value.findIndex((panel) => panel.name === name && panel.visible);

	}

	setTabVisibleByIndex = (index: number, value: boolean) => {
		this.panels.value[index].visible = value;
		this.visiblePanels.value = this.panels.value.filter(i => i.visible == true);
		this.activeIndex.value = this.getVisibleTabIndexByName(this.panels.value[index].name);
	}


	panels = ref<Array<{ name: string, header: string, visible: boolean }>>([])

	visiblePanels = ref<Array<{ name: string, header: string, visible: boolean }>>([]);








}